import { useQuery } from '@tanstack/react-query';
import { disManager, WebDisMetadata } from '@m43/core';
import { electronBridge, ElectronDexMetadata } from '../electron-bridge/electron-bridge';

export function useDexMetadata() {
    const query = useQuery(
        ['dex-metadata'],
        async (): Promise<ElectronDexMetadata | WebDisMetadata | undefined> => {
            if (electronBridge) {
                return await electronBridge.getDexMetadata();
            }
            const disManagerResponse = await disManager.getMetadata();

            return disManagerResponse?.data;
        },
        {
            cacheTime: Infinity,
            staleTime: Infinity,
            refetchOnMount: false,
        }
    );

    return { dexMetadata: query.data, isLoading: query.isLoading };
}
